module.exports = __webpack_public_path__ + "static/js/1.369d1f2c.chunk.worker.js"